<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

        <div class="content" v-else>
            <h1>Autoři</h1>
            <v-layout class="layout--controls">
                <v-btn
                        color="primary"
                        type="submit"
                        class="button--top control"
                        @click="addAuthor()"
                >Vytvořit autora</v-btn>
                <v-text-field
                        class="input--search control"
                        placeholder="Vyhledat"
                        outlined
                        v-model="search"
                ></v-text-field>
            </v-layout>
            <v-layout class="table-items">



                <v-data-table

                        :headers="headers"
                        :items="items"
                        :search="search"
                        :loading="false"
                        locale="cs"
                        item-key="name"
                        :items-per-page="30"
                        :mobile-breakpoint='0'
                        class="elevation-1 full-width frankjoy-table"
                >

                    <template slot="body" slot-scope="props">
                        <tbody>
                        <tr v-for="item in props.items" :key="item.id" >
                            <router-link :to="{name:'AuthorsDetail', params: {id: item.id}}" >
                                <td class="">
                                    <span v-if="item.image" class="image-table image-table--photo" :style="'background-image:url('+item.image+')'"></span>
                                    <span v-else class="image-table"></span>
                                </td>
                                <td class="">{{item.id}}</td>
                                <td class="">{{item.forename}}</td>
                                <td class="">{{item.surname}}</td>
                                <td class="">{{item.slug}}</td>

                                <td class="small bold">
                                    <span v-if="item.published" class="published">ANO</span>
                                    <span v-else class="published published--not">NE</span>
                                </td>
                                <td class="small bold">
                                    <span class="seo seo--checked" v-if="item.seo">
                                        <v-icon>check</v-icon>
                                    </span>
                                    <span class="seo" v-else>

                                    </span>
                                </td>
                                <td class="right">
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            class="button--small"
                                    >Detail</v-btn>
                                </td>
                            </router-link>



                        </tr>
                        <div v-if="props.items.length == 0" class="text-no-results">
                            <p>Žádný autor nebyl nalezen</p>
                        </div>
                        </tbody>

                    </template>


                    <template slot="footer" slot-scope="totals">

                        <div class="table-footer"  v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
                            <div class="table-footer__text">
                                Počet autorů na stránce
                            </div>
                            <div class="table-footer__pages">
                                <span v-if="totals.props.pagination.pageStop > 0"><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart + 1}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                                <span v-else><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                            </div>
                        </div>
                    </template>
                </v-data-table>


            </v-layout>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Readers',
        components: {
        },



        data() {
            return {
                loaded: false,
                search: '',
                headers: [
                    //  { text: '', value: '',  align: 'left',sortable: false },
                    { text: '', value: 'image', sortable: false,  align: 'left',  },
                    { text: 'ID', value: 'id',  align: 'left',  },
                    { text: 'Jméno', value: 'forename',  align: 'left',  },
                    { text: 'Příjmení', value: 'surname',  align: 'left',  },
                    { text: 'Slug', value: 'slug',  align: 'left',  },
                    { text: 'Publikováno', value: 'published',  align: 'left',  },
                    { text: 'SEO', value: 'seo',  align: 'left',  },
                    { text: '', value: 'controls',  align: 'right',  }
                ],
                items: []
            }
        },

        created() {

            this.fetchData();


        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){

        },
        methods: {
            addAuthor(){
                this.$router.push({name: 'AuthorsDetail', params: {id: 'add'}})
            },
            formatCreatedAt(date){
                if(date){
                    return moment(date).format('D.M.YYYY - HH:mm');
                }else{
                    return null;
                }

            },
            fetchData(){

                this.$axios.get('/admin/authors').then((response) => {
                    this.items = response.data.authors;
                    this.loaded = true;
                }).catch((e) => {
                    this.loaded = true;
                });
            }

        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>